/**
 * @param {{ computedValues: { url: string } }} [item]
 * @returns {boolean}
 */
export function getIs2024ScoreboardEmbed(item) {
  return Boolean(item?.computedValues?.url?.match('politics/2024-elections/scoreboard/embed'));
}
